import React from 'react';
import Chart from 'react-apexcharts';

function StackedBarChart({ data }) {
  // Define colors for predefined milestones
  const PREDEFINED_COLORS = {
    10: '#0000a0', // 10 Years - Navy Blue
    15: '#00d7b9', // 15 Years - Dark Turquoise
    20: '#ffdc00', // 20 Years - Gold
    25: '#00dcfa', // 25 Years - Turquoise
    30: '#a6db00', // 30 Years - Lime Green
    50: '#9600ff', // 50 Years - Blue Violet
    70: '#ff32a0'  // 70 Years - Deep Pink
  };

  // Generate a color for milestones not predefined
  const generateColor = (index) => {
    const colors = [
      '#ff5733', '#33ff57', '#3357ff', '#ff33a8', '#33fff1', '#a833ff', '#ffb833'
    ];
    return colors[index % colors.length];
  };

  // Collect milestones dynamically while preserving the order of their first appearance
  let allMilestones = [];
  const milestoneSet = new Set();
  data.forEach(yearData => {
    Object.keys(yearData).forEach(milestone => {
      if (milestone !== 'x' && !milestoneSet.has(milestone)) {
        milestoneSet.add(milestone);
        allMilestones.push(milestone);
      }
    });
  });

  // Convert milestones to numbers, sort them in ascending order, and convert back to strings
  allMilestones = allMilestones
    .map(milestone => parseInt(milestone, 10))
    .sort((a, b) => a - b)
    .map(milestone => milestone.toString());

  // Create a comprehensive COLORS object including dynamically generated colors
  const COLORS = {};
  let colorIndex = 0;
  allMilestones.forEach(milestone => {
    COLORS[milestone] = PREDEFINED_COLORS[milestone] || generateColor(colorIndex++);
  });

  // Transform data for the chart
  const seriesData = allMilestones.map(milestone => ({
    name: `${milestone} Years`,
    data: data.map(yearData => yearData[milestone] || 0)
  }));

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: true
      }
    },
    colors: allMilestones.map(milestone => COLORS[milestone]),
    xaxis: {
      categories: data.map(yearData => yearData.x), // Extract years for the x-axis
      title: {
        text: ''
      }
    },
    yaxis: {
      title: {
        text: 'Milestone Count',
        style: {
          fontSize: "13px",
          fontWeight: "700",
          color: "#333",
          fontFamily: "Mars Centra",
        },
      }
    },
    legend: {
      show: false // Hide default legend to use custom legend
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} count`
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
      }
    },
    dataLabels: {
      enabled: false
    }
  };

  return (
    <div className="stacked-bar-chart">
      <Chart options={options} series={seriesData} type="bar" height={400} />
      <div
        style={{
          marginTop: '10px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        {allMilestones.map(milestone => (
          <div key={milestone} style={{display:'flex'}}>
            <span
              style={{
                width: '15px',
                height: '15px',
                display: 'inline-block',
                backgroundColor: COLORS[milestone],
                marginRight: '10px',
                borderRadius: '3px',
              }}
            >
            </span>
            <span style={{
              fontSize: '14px',
              color: '#333',
              marginRight: '10px'
            }}>{milestone} Years</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StackedBarChart;
